import React, { useEffect } from 'react';

import type { ImmutableMap } from 'js/src/libs/consts';
import ContentfulTools from 'js/src/libs/contentful-tools';
import type { ContentfulPageType } from 'js/src/libs/contentful-utils';

type Props = {
    pageData: ImmutableMap<ContentfulPageType>;
};

const ContentfulHeader = React.memo(function ContentfulHeader({ pageData }: Props) {
    const structuredData = pageData.get('structured_data');

    useEffect(() => {
        if (!structuredData) return;
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(structuredData);
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, [structuredData]);

    const pageTitle = pageData.get('page_title');
    const description = pageData.get('description');
    const slug = pageData.get('slug');
    const imageUrl = pageData.get('image')?.get('file')?.get('url');
    const url = slug ? `https://lumen5.com/${slug}` : undefined;

    return (
        <>
            {pageTitle && <title>{pageTitle}</title>}
            {pageTitle && <meta property="og:title" content={pageTitle} />}
            {description && <meta name="description" content={description} />}
            {description && <meta property="og:description" content={description} />}
            {url && <meta property="og:url" content={url} />}
            {url && <link rel="canonical" href={url} />}
            {imageUrl && (
                <meta
                    property="og:image"
                    content={ContentfulTools.getUrl(imageUrl, { width: 1200 })}
                />
            )}
            <meta property="og:site_name" content="Lumen5" />
            <meta property="og:type" content="website" />
        </>
    );
});

export default ContentfulHeader;
